import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class HighlightOptionsRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iconState: false,
    };
  }

  handleMouseDown = event => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  };

  handleMouseEnter = event => {
    this.setState({ iconState: true });
    this.props.onFocus(this.props.option, event);
  };

  handleMouseOut = () => {
    this.setState({ iconState: false });
  };

  handleMouseMove = event => {
    if (this.props.isFocused) {
      return;
    }
    this.props.onFocus(this.props.option, event);
  };

  render() {
    const optionStyle = {
      borderRadius: 3,
      display: 'inline-block',
      marginRight: 10,
      position: 'relative',
      top: -2,
      verticalAlign: 'middle',
      width: '20px',
    };

    const highestIndexStyle = {
      borderRadius: 3,
      display: 'inline-block',
      marginRight: 15,
      position: 'relative',
      top: -2,
      verticalAlign: 'middle',
      width: '15px',
    };

    return (
      <div
        className={this.props.className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        onMouseOut={this.handleMouseOut}
        title={this.props.option.title}
      >
        <img
          src={
            this.state.iconState
              ? this.props.option.selectedIcon
              : this.props.option.icon
          }
          style={(this.props.option.label === 'Highest Index') ? highestIndexStyle : optionStyle}
          alt={this.props.option.label}
        />
        {this.props.children}
      </div>
    );
  }
}

HighlightOptionsRenderer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  // isDisabled: PropTypes.bool,
  isFocused: PropTypes.bool,
  // isSelected: PropTypes.bool,
  onFocus: PropTypes.func,
  onSelect: PropTypes.func,
  option: PropTypes.shape({
    title: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string,
    selectedIcon: PropTypes.string,
  }),
};
